export const isLocalhost = () => [
  'localhost',
  '127.0.0.1',
].includes(window.location.hostname);